/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Images/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ActiveTab from './ActiveTab/index'
import React from 'react'
import Tabs from './Tabs/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Images({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/TreatmentCard/Images"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 alignSelf="flex-start"
 flexGrow={0}
 flexBasis="auto"
 height={260}
 width={312}
 marginTop={isMedia.mobile ? "8px" : "0px"}
>
{childProps => (
<React.Fragment>
<Tabs
{...childProps}
  viewPath={`${viewPath}/Tabs`}
/>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={dtSpaceXxs}
 paddingRight={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 paddingLeft={dtSpaceXxs}
>
{childProps => (
<ActiveTab
{...childProps}
  viewPath={`${viewPath}/ActiveTab`}
/>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}